<template>
  <div class="modal" v-if="isshow">
    <div class="content">
      <span class="content-title">{{title}}</span>
      <div class="pwd">
        <div v-for="(item, index) of 6" :key="index" class="pwd-item">
          <div v-if="index < pwd.length" class="pwd-dot"></div>
        </div>
      </div>
      <div v-if="tips" class="content-tips" :style="tipsColor">{{tips}}</div>
    </div>
    <div class="keyboard" :class="isIosX?'pd-34':''">
      <div v-for="(item, index) of list" :key="index" class="keyboard-item" @touchstart="handleTouchStart(index)" @touchend="handleTouchEnd(item)">
        <img v-if="item == 'del'" :src="paydelete" class="keyboard-delete" />
        <span v-else-if="item == '取消'" @click="cancel" class="keyboard-cancel">{{item}}</span>
        <span v-else>{{item}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      isshow: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        default: '请输入支付密码'
      },
      tips: {
        type: String,
        default: ''
      },
      tipsColor: {
        type: String,
        default: 'color: rgba(0, 0, 0, 0.3);'
      }
    },
    data() {
      return {
        current: null,
        list: [1, 2, 3, 4, 5, 6, 7, 8, 9, '取消', 0, 'del'],
        pwd: '',
        paydelete: require("@/assets/groupRob/pay-delete.png"),
        isIosX: false,
      };
    },
    watch: {
      isshow(e) {
        this.pwd = '';
      }
    },
    created() {
      this.isIosX = this.isIphoneX()
      this.pwd = ''
    },
    methods: {
      handleTouchStart(e) {
        this.current = e;
      },
      handleTouchEnd(e) {
        this.current = null;
        if (e == '取消') {
          return this.cancel()
        }
        if (e == 'del') {
          this.pwd = this.pwd.slice(0, -1);
        } else if (this.pwd.length < 6) {
          this.pwd = this.pwd + e.toString();
          if (this.pwd.length == 6) {
            setTimeout(() => {
              this.submit();
            }, 200);
          }
        }
      },
      clear(){
        this.pwd = ''
      },
      cancel() {
        this.$emit('update:isshow', false);
      },
      submit() {
        this.$emit('submit', this.pwd);
      }
    }
  }
</script>

<style lang="less" scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end !important;

    .content {
      width: calc(100% - 32px);
      background-color: #FFFFFF;
      display: flex;
      flex-direction: column;
      padding: 20px 21px 22px 22px;
      // border-radius: 10px;

      .content-title {
        line-height: 28px;
        color: rgba(0, 0, 0, 1);
        font-size: 18px;
        font-weight: 600;
        text-align: center;
      }

      .pwd {
        margin-top: 22px;
        display: flex;

        .pwd-item {
          flex: 1;
          height: 50px;
          border: 1px solid rgba(166, 166, 166, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: none;

          &:last-child {
            border-right: 1px solid rgba(166, 166, 166, 1);
          }

          .pwd-dot {
            width: 16px;
            height: 16px;
            border-radius: 5px;
            background-color: #000;
          }
        }
      }

      .content-tips {
        font-size: 14px;
        margin-top: 18px;
        line-height: 14px;
      }
    }

    .keyboard {
      width: 100%;
      height: 310px;
      background-color: rgba(237, 237, 237, 1);
      // border-radius: 12px 12px 0 0;
      padding: 15px 12px 35px 13px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;

      .keyboard-item {
        flex: 0 0 calc(100% / 3 - 8px);
        background-color: #FFFFFF;
        box-sizing: border-box;
        border-radius: 4px;
        margin: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(0, 0, 0, 1);
        font-size: 22px;
        line-height: 27px;
        font-weight: bold;

        &.active {
          background-color: rgba(0, 0, 0, 0.1);
        }

        .keyboard-delete {
          width: 20px;
          height: 20px;
        }

        .keyboard-cancel {
          font-size: 14px;
          font-weight: normal;
          line-height: 20px;
        }
      }
    }

    .pd-34 {
      padding-bottom: 69px;
    }
  }
</style>